import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import appMenuReducer from '../reducers/appMenuReducer';

const configureStore = (railsProps) => (
  createStore(appMenuReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
